module.exports = __webpack_public_path__ + "media/images/sites-46da1af6.svg";